/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const TransactionAmountR = t.interface({
  amount: t.Integer
});

// optional attributes
const TransactionAmountO = t.partial({
  currency: t.string,

  currencyNumber: t.string,

  decimalDigits: t.Integer
});

export const TransactionAmount = t.intersection(
  [TransactionAmountR, TransactionAmountO],
  "TransactionAmount"
);

export type TransactionAmount = t.TypeOf<typeof TransactionAmount>;
